import { Injectable } from '@angular/core';
import { BreadcrumbItem, slugify, StatefulService } from '@woolworthsnz/styleguide';
import { RecipeCategoryResponse } from '@woolworthsnz/trader-api';

@Injectable({
	providedIn: 'root',
})
export class RecipeBreadcrumbService extends StatefulService<{ breadcrumbs: BreadcrumbItem[] }> {
	constructor() {
		super({ breadcrumbs: [] });
	}

	setBreadcrumbs(items?: BreadcrumbItem[], category?: RecipeCategoryResponse): void {
		const recipesBreadcrumb: BreadcrumbItem = {
			text: 'Recipes',
			queryParams: null,
		};

		const initialBreadcrumbs: BreadcrumbItem[] = [recipesBreadcrumb];

		// We only want 'Recipes' to have a link if there are more breadcrumbs
		if (items?.length || category) {
			recipesBreadcrumb.routeUrl = '/recipes';
		}

		// Input breadcrumbs take precedence over an input category, so we return here
		if (items?.length) {
			this.setState({ breadcrumbs: [...initialBreadcrumbs, ...items] });
			return;
		}

		if (category) {
			this.setState({ breadcrumbs: [...initialBreadcrumbs, ...this.mapCategoryToBreadcrumbs(category)] });
			return;
		}

		this.setState({ breadcrumbs: initialBreadcrumbs });
	}

	private mapCategoryToBreadcrumbs(category: RecipeCategoryResponse): BreadcrumbItem[] {
		const breadcrumbs: BreadcrumbItem[] = [];

		// Completely skip categories with no description in the breadcrumb
		if (category.parentCategory?.description) {
			breadcrumbs.push({
				text: category.parentCategory.description,
				routeUrl: `/recipes/${category.parentCategory.id}/${slugify(category.parentCategory.description)}`,
				queryParams: null,
			});
		}

		// The last breadcrumb shouldn't link anywhere
		if (category.description) {
			breadcrumbs.push({
				text: category.description,
				queryParams: null,
			});
		}

		return breadcrumbs;
	}
}
